import React, { useContext, useEffect } from "react";
import { List } from '@mui/material'
import { meRepository } from '~/src/repositories'
import useSWR from 'swr'
import { CountContext } from "~/src/routes";

import { TNestedSidebarItemProps, TSidebarItemProps } from '~/src/types/sidebar'
import * as Constants from '~/src/constants'
import {
  PersistentDrawer,
  SidebarListItem,
  SidebarNestedListItem,
} from '~/src/components/molecules'

// react-router-dom wrapper
import { SidebarLink } from './Sidebar.styles'

export type TSidebarProps = {
  open?: boolean
}

const data: TNestedSidebarItemProps[] = Constants.SIDEBAR_LIST

/**
 * Sidebar Component
 * TODO:: cssを少し修正する
 * @example
 * ```ts
 *  <Sidebar />
 * ```
 * @param __namedParameters TSidebarProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const Sidebar: React.FC<TSidebarProps> = ({ open = false }): JSX.Element => {
  const { count, setCount } = useContext(CountContext)
  const { data: countData } = useSWR(['/me/status'], () => meRepository.getMeStatus())

  useEffect(() => {
    if (typeof countData?.data.unreadRequestOrdersCount !== 'undefined')
    setCount(countData?.data.unreadRequestOrdersCount)
  }, [countData])

  useEffect(() => {
    if (typeof count !== 'undefined')
      setCount(count)
  }, [count])

  return (
    <PersistentDrawer drawerOpen={open}>
      <List
        sx={{ width: '100%', bgcolor: 'background.paper', paddingTop: '0px'}}
        dense={false}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {data.map((item: TNestedSidebarItemProps) => {
          // Early return
          if (item.list.length === 0) {
            return (
              <SidebarLink key={item.text} to={item.link}>
                <SidebarListItem key={item.text} icon={item.icon} text={item.text} count={count}/>
              </SidebarLink>
            )
          }
          return (
            <SidebarNestedListItem key={item.text} icon={item.icon} text={item.text}>
              {item.list.map((nestedItem: TSidebarItemProps) => (
                <SidebarLink key={nestedItem.text} to={nestedItem.link}>
                  <SidebarListItem
                    key={nestedItem.text}
                    icon={nestedItem.icon}
                    text={nestedItem.text}
                    count={count}
                  />
                </SidebarLink>
              ))}
            </SidebarNestedListItem>
          )
        })}
      </List>
    </PersistentDrawer>
  )
}
